const lexicon = {
  šarāqum: {
    themeVowel: "i",
    root: ["š", "r", "q"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to steal",
  },
  šakānum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "k", "n"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to place",
  },
  ṣabātum: {
    themeVowel: "a",
    root: ["ṣ", "b", "t"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to seize",
  },
  damāqum: {
    themeVowel: "i",
    root: ["d", "m", "q"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    meaning: "to be good",
  },
  danānum: {
    themeVowel: "i",
    root: ["d", "n", "n"],
    verbalAdjectiveVowel: " ",
    verbClass: "stative",
    meaning: "to be strong",
  },
  ḫalāqum: {
    themeVowel: "i",
    root: ["ḫ", "l", "q"],
    verbalAdjectiveVowel: undefined,
    meaning: "to disappear",
  },
  kašādum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["k", "š", "d"],
    verbalAdjectiveVowel: undefined,
    meaning: "to arrive, to reach, to conquer",
  },
  maḫāṣum: {
    themeVowel: "a",
    root: ["m", "ḫ", "ṣ"],
    verbalAdjectiveVowel: undefined,
    meaning: "to strike, to hit, to kill",
  },
  maqātum: {
    themeVowel: "u",
    root: ["m", "q", "t"],
    verbalAdjectiveVowel: undefined,
    meaning: "to fall, to happen",
  },
  marāṣum: {
    themeVowel: "a",
    root: ["m", "r", "ṣ"],
    verbalAdjectiveVowel: "u",
    verbClass: "stative",
    meaning: "to be sick, difficult",
  },
  rapāšum: {
    themeVowel: "i",
    root: ["r", "p", "š"],
    verbalAdjectiveVowel: "a",
    verbClass: "stative",
    meaning: "to be wide, broad",
  },
  balāṭum: {
    themeVowel: "u",
    root: ["b", "l", "ṭ"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to live, to be alive, to be healthy",
  },
  gamārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["g", "m", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to bring to an end, to settle, to finish",
  },
  kanākum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["k", "n", "k"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to seal",
  },
  maḫārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["m", "ḫ", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to accept, to receive, to meet, to please",
  },
  šalāmum: {
    themeVowel: "i",
    root: ["š", "l", "m"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become well, to succeed, to be completed",
  },
  nadānum: {
    themeVowel: "i",
    root: ["n", "d", "n"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to give, to deliver",
  },
  naqārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "q", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to tear down, to destroy",
  },
  nasāḫum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "s", "ḫ"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to remove, to transfer, to move on",
  },
  naṣārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "ṣ", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to watch (over), to protect",
  },
  paqādum: {
    themeVowel: "i",
    root: ["p", "q", "d"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to hand over, to entrust, to supply, to take care of, to deliver",
  },
  pašāšum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["p", "š", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to anoint, to rub, to smear",
  },
  qatānum: {
    themeVowel: "i",
    root: ["q", "t", "n"],
    verbalAdjectiveVowel: "a",
    verbClass: "stative",
    meaning: "to become thin, narrow",
  },
  rakābum: {
    themeVowel: "a",
    root: ["r", "k", "b"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to mount, to ride, to board",
  },
  banûm: {
    themeVowel: "i",
    root: ["b", "n", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to build",
  },
  ḫadûm: {
    themeVowel: "u",
    root: ["ḫ", "d", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to rejoice, to be happy",
  },
  leqûm: {
    themeVowel: "e",
    root: ["l", "q", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to take, to accept",
  },
  malûm: {
    themeVowel: "a",
    root: ["m", "l", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become full, to fill with",
  },
  rabûm: {
    themeVowel: "i",
    root: ["r", "b", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become large, great, to grow",
  },
  šemûm: {
    themeVowel: "e",
    root: ["š", "m", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to hear, to listen",
  },
  zakûm: {
    themeVowel: "u",
    root: ["z", "k", "Ø"],
    verbalAdjectiveVowel: "u",
    verbClass: "stative",
    meaning: "to become clean, clear",
  },
  amārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["Ø", "m", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to see, to find, ro read",
  },
  arākum: {
    themeVowel: "i",
    root: ["Ø", "r", "k"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    meaning: "to be long, to last long, to be delayed",
    dMeaning: "to lengthen, to extend, to delay",
  },
  epēšum: {
    themeVowel: "u",
    durativeVowel: "e",
    root: ["Ø", "p", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to do",
    shMeaning: "to have (sth) built, to direct work",
  },
  ezēbum: {
    themeVowel: "i",
    root: ["Ø", "z", "b"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to leave, to divorce",
    shMeaning: "to have (a document) made out, to save (persons, cities)",
  },
  alākum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["Ø", "l", "k"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to go",
  },
  aḫāzum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["Ø", "ḫ", "z"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to seize, to take, to marry, to learn",
    dMeaning: "to mount, to set, to overlay",
  },
  erēbum: {
    themeVowel: "u",
    root: ["Ø", "r", "b"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to leave, to divorce",
  },
  ešērum: {
    themeVowel: "i",
    root: ["Ø", "š", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to do",
    shMeaning: "to move straight toward, to set straight",
  },
  kânum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["k", "Ø", "n"],
    verbalAdjectiveVowel: "ī",
    verbClass: "stative",
    meaning: "to be true, honest, correct",
  },
  qiāšum: {
    themeVowel: "i",
    root: ["q", "Ø", "š"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to give, to bestow, to grant",
  },
  šâmum: {
    themeVowel: "a",
    root: ["š", "Ø", "m"],
    verbalAdjectiveVowel: "ā",
    verbClass: "active",
    meaning: "to buy, to purchase",
  },
  nêrum: {
    themeVowel: "e",
    root: ["n", "Ø", "r"],
    verbalAdjectiveVowel: "ē",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to kill, to slay, to defeat",
  },
  agārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["Ø", "g", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to hire, to rent",
  },
  enēšum: {
    themeVowel: "i",
    root: ["Ø", "n", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to be weak, powerless",
    dMeaning: "to make weak, to weaken",
  },
  miādum: {
    themeVowel: "i",
    root: ["m", "Ø", "d"],
    verbalAdjectiveVowel: "ā",
    verbClass: "active",
    meaning: "to increase, to become numerous",
  },
  šatûm: {
    themeVowel: "i",
    root: ["š", "t", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to drink",
  },
  târum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["t", "Ø", "r"],
    verbalAdjectiveVowel: "ā",
    verbClass: "active",
    meaning: "to return, to come back",
  },
  ṭiābum: {
    themeVowel: "i",
    root: ["ṭ", "Ø", "b"],
    verbalAdjectiveVowel: "ā",
    verbClass: "stative",
    meaning: "to become pleasant, sweet",
  },
  watārum: {
    themeVowel: "i",
    root: ["w", "t", "r"],
    verbalAdjectiveVowel: "a",
    verbClass: "stative",
    I_eVerb: true,
    verbClass: "stative",
    meaning: "to become exceeding, to exceed",
    dMeaning: "to augment, to increase",
  },
  wašābum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["w", "š", "b"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: false,
    verbClass: "active",
    meaning: "to sit, to remain",
    shMeaning:
      "to install (officers), to garrison (soldiers), to settle (people)",
  },
  babālum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["b", "b", "l"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: false,
    verbClass: "active",
    meaning: "to carry, to bear, to transport",
  },
  akālum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["Ø", "k", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to eat, to consume, to use",
    shMeaning: "to feed",
  },
  edēšum: {
    themeVowel: "i",
    root: ["Ø", "d", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to be new",
    dMeaning: "to renew, to restore",
  },
  labārum: {
    themeVowel: "i",
    root: ["l", "b", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become old, to last, to endure",
  },
  mâtum: {
    themeVowel: "u",
    root: ["m", "Ø", "t"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to die",
  },
  šiābum: {
    themeVowel: "i",
    root: ["š", "Ø", "b"],
    verbalAdjectiveVowel: "ī",
    verbClass: "stative",
    meaning: "to become old, grey",
  },
  kaṣārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["k", "ṣ", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to bind, to tie, to join",
  },
  parāsum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["p", "r", "s"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to divide, to separate",
  },
  šaṭārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "ṭ", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to inscribe, to write, to register, to assign",
  },
  ṭarādum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["ṭ", "r", "d"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to send, to dispatch, to drive away",
  },
  nakāsum: {
    themeVowel: "i",
    root: ["n", "k", "s"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to cut off, to cut down",
  },
  nasākum: {
    themeVowel: "u",
    root: ["n", "s", "k"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to throw, to shoot, to pile up",
  },
  naṭālum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "ṭ", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to see, to look at, to consider",
  },
  rašûm: {
    themeVowel: "i",
    root: ["r", "š", "Ø"],
    verbalAdjectiveVowel: undefined,
    meaning: "to receive, to gain",
  },
  ṭeḫûm: {
    themeVowel: "e",
    root: ["ṭ", "ḫ", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to go near, to approach",
  },
  ḫepûm: {
    themeVowel: "e",
    root: ["ḫ", "p", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to smash, to destroy, to break",
  },
  kanāšum: {
    themeVowel: "u",
    root: ["k", "n", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to bow down, to submit",
  },
  pašāḫum: {
    themeVowel: "a",
    root: ["p", "š", "ḫ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to refresh oneself, to calm down",
  },
  saḫāpum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["s", "ḫ", "p"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to cover, to spread over, to overwhelm",
  },
  ragāmum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["r", "g", "m"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to shout, to call, to complain",
  },
  tamûm: {
    themeVowel: "a",
    root: ["t", "m", "Ø"],
    verbalAdjectiveVowel: undefined,
    meaning: "to swear, to take an oath",
  },
  zâzum: {
    themeVowel: "u",
    root: ["z", "Ø", "z"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to divide, to separate",
  },
  apālum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["Ø", "p", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to answer, to reply, to pay",
  },
  dâkum: {
    themeVowel: "u",
    root: ["d", "Ø", "k"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to kill, to execute, to defeat",
  },
  diānum: {
    themeVowel: "i",
    root: ["d", "Ø", "n"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to judge, to give a judgment",
  },
  emēdum: {
    themeVowel: "i",
    root: ["Ø", "m", "d"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to lean against, to touch, to reach",
    dMeaning: "to lean, to push, to rest against",
  },
  qabûm: {
    themeVowel: "i",
    root: ["q", "b", "Ø"],
    verbalAdjectiveVowel: undefined,
    meaning: "to say, to speak, to give orders",
  },
  sadārum: {
    themeVowel: "a",
    durativeVowel: "u",
    root: ["s", "d", "r"],
    verbalAdjectiveVowel: "i",
    meaning: "to arrange, to put in order",
  },
  maqātum: {
    themeVowel: "u",
    root: ["m", "q", "t"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to fall, to collapse, to happen",
  },
  madādum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["m", "d", "d"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to measure out",
  },
  šapārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "p", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to send (someone/a message)",
  },
  warādum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["w", "r", "d"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: false,
    verbClass: "active",
    meaning: "to descend, to go/come down",
  },
  waṣābum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["w", "ṣ", "b"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: false,
    verbClass: "active",
    meaning: "to add, to increase",
  },
  etēqum: {
    themeVowel: "i",
    root: ["Ø", "t", "q"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to pass along, to advance, to avoid",
  },
  palāḫum: {
    themeVowel: "a",
    root: ["p", "l", "ḫ"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to fear, to worship, to respect",
  },
  petûm: {
    themeVowel: "e",
    root: ["p", "t", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to open",
  },
  redûm: {
    themeVowel: "e",
    root: ["r", "d", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to escort, to lead, to drive",
  },
  šaqālum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "q", "l"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to weigh out, to pay",
  },
  takālum: {
    themeVowel: "a",
    root: ["t", "k", "l"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to trust",
  },
  tebûm: {
    themeVowel: "e",
    root: ["t", "b", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to arise, to stand up, to occur",
  },
  kalûm: {
    themeVowel: "a",
    root: ["k", "l", "Ø"],
    verbalAdjectiveVowel: undefined,
    meaning: "to detain, to delay, to prevent",
  },
  paṭārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["m", "q", "t"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to loosen, to remove, to end",
  },
  baqārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["b", "q", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to claim, to contest",
  },
  kabātum: {
    themeVowel: "i",
    root: ["k", "b", "t"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    meaning: "to become heavy, fat, important, difficult",
  },
  nasāqum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "s", "q"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to choose, to select",
  },
  palāšum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["p", "l", "š"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to pierce, to break throughš",
  },
  riābum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["r", "Ø", "b"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to replace, to give back",
  },
  šarākum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "r", "k"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to give, to bestow",
  },
  zaqāpum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["z", "q", "p"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to erect, to set up, to plant",
  },
  erēšum: {
    themeVowel: "i",
    root: ["Ø", "r", "š"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to ask, to request, to wish",
  },
  pašārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["p", "š", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to loosen, to release, to explain",
  },
  râmum: {
    themeVowel: "a",
    root: ["r", "Ø", "m"],
    verbalAdjectiveVowel: "ā",
    verbClass: "active",
    meaning: "to love, to care for",
  },
  zakārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["z", "k", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to declare, to speak, to name",
  },
  šadādum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "d", "d"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to pull, to drag, to stretch",
  },
  šapākum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["š", "p", "k"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to heap up, to pile up, to store",
  },
  elûm: {
    themeVowel: "i",
    root: ["Ø", "l", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to go up, to ascend",
    dMeaning: "to raise, to elevate",
    shMeaning: "to send/lead/take/bring up, to produce a witness",
  },
  lawûm: {
    themeVowel: "i",
    root: ["l", "w", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to go around, to circle, to surround",
  },
  naˀādum: {
    themeVowel: "i",
    root: ["n", "ˀ", "d"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to pay attention, to be concerned",
  },
  nawārum: {
    themeVowel: "i",
    root: ["n", "w", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become bright, to shine",
  },
  nâḫum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["n", "Ø", "ḫ"],
    verbalAdjectiveVowel: "ē",
    verbClass: "stative",
    meaning: "to rest, to become peaceful",
  },
  niālum: {
    themeVowel: "i",
    root: ["n", "Ø", "l"],
    verbalAdjectiveVowel: "ī",
    verbClass: "stative",
    meaning: "to lie downt",
  },
  nadûm: {
    themeVowel: "i",
    root: ["n", "d", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to throw down, to set down, to neglect",
  },
  nesûm: {
    themeVowel: "e",
    root: ["n", "s", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to become far away, to depart",
  },
  eˀēlum: {
    themeVowel: "i",
    root: ["Ø", "ˀ", "l"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to bind (by an agreement)",
  },
  êrum: {
    themeVowel: "e",
    root: ["ˀ", "Ø", "r"],
    verbalAdjectiveVowel: "ē",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to awaken, to be awaken",
  },
  wârum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["w", "Ø", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to advance against, to attack",
  },
  wiāṣum: {
    themeVowel: "i",
    root: ["w", "Ø", "ṣ"],
    verbalAdjectiveVowel: "ī",
    verbClass: "stative",
    meaning: "to become small, insufficient",
  },
  waṣûm: {
    themeVowel: "i",
    root: ["w", "ṣ", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to go out, to leave",
    shMeaning: "to send away, to expel, to release, to rent, to hire",
  },
  watûm: {
    themeVowel: "a",
    root: ["w", "t", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to find, to discover",
  },
  warûm: {
    themeVowel: "u",
    root: ["w", "r", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to bring, to lead",
  },
  leˀûm: {
    themeVowel: "i",
    root: ["l", "ˀ", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to be able",
  },
  bâˀum: {
    themeVowel: "a",
    root: ["b", "Ø", "ˀ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to walk along",
  },
  êwum: {
    themeVowel: "i",
    root: ["Ø", "w", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to become, to change, to turn into",
  },
  nawûm: {
    themeVowel: "i",
    root: ["n", "w", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "stative",
    meaning: "to be abandoned, in ruins",
  },
  nêˀum: {
    themeVowel: "e",
    root: ["n", "Ø", "ˀ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to turn around, to loosen",
  },
  nakārum: {
    themeVowel: "i",
    root: ["n", "k", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to become different, hostile, to change, to dispute",
  },
  našûm: {
    themeVowel: "i",
    root: ["n", "š", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to lift, to raise, to carry, to accept, to receive",
  },
  qerēbum: {
    themeVowel: "e",
    root: ["q", "r", "b"],
    verbalAdjectiveVowel: "u",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to draw near, to approach",
  },
  maṣûm: {
    themeVowel: "i",
    root: ["m", "ṣ", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    meaning: "to be equal, to be sufficient",
  },
  saḫārum: {
    themeVowel: "u",
    root: ["s", "ḫ", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to go around, to surround, to turn",
  },
  šebērum: {
    themeVowel: "e",
    root: ["š", "b", "r"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to break",
  },
  tabālum: {
    themeVowel: "a",
    root: ["t", "b", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to take away, to carry away",
  },
  bašûm: {
    themeVowel: "i",
    root: ["b", "š", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to exist, to be present",
  },
  sakātum: {
    themeVowel: "u",
    root: ["s", "k", "t"],
    verbalAdjectiveVowel: "i",
    verbClass: "stative",
    meaning: "to be silent",
  },
  ḫiārum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["ḫ", "Ø", "r"],
    verbalAdjectiveVowel: "ī",
    verbClass: "active",
    meaning: "to chose a mate",
  },
  lamādum: {
    themeVowel: "a",
    root: ["l", "m", "d"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to learn, to study, to understand",
    dMeaning: "to inform",
  },
  manûm: {
    themeVowel: "u",
    root: ["m", "n", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to count, to include, to hand over",
  },
  kullumum: {
    themeVowel: undefined,
    onlyDstem: true,
    root: ["k", "l", "m"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: undefined,
    dMeaning: "to show, to reveal, to produce (document)",
  },
  ebēbum: {
    themeVowel: "i",
    root: ["Ø", "b", "b"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to become clean",
    dMeaning: "to clean, to purify, to clear",
  },
  erēšum: {
    themeVowel: "i",
    root: ["Ø", "r", "š"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to seed, to plant, to cultivate",
  },
  "esērum-a": {
    themeVowel: "i",
    root: ["Ø", "s", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to enclose, to shut in",
    dMeaning: "to enclose, to take captive",
  },
  "esērum-b": {
    themeVowel: "i",
    root: ["Ø", "s", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to press, to put under pressure, to collect",
    dMeaning: "to press, to put under pressure, to collect",
  },
  gerûm: {
    themeVowel: "e",
    root: ["g", "r", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to be hostile",
    dMeaning: "to be hostile",
  },
  lapātum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["l", "p", "t"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to touch, to strike, to apply, to assign",
    dMeaning: "to touch, to tarry, to delay",
  },
  sanāqum: {
    themeVowel: "i",
    root: ["s", "n", "q"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to arrive at, to reach, to check",
    dMeaning: "to check, to control, to question",
  },
  uššurum: {
    themeVowel: undefined,
    onlyDstem: true,
    root: ["w", "š", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: undefined,
    dMeaning: "to release, to set free",
  },
  edûm: {
    themeVowel: "e",
    meaning: "to know",
    root: ["w", "d", "Ø"],
    I_eVerb: true,
    dMeaning: "to mark, to inform, to recognize, to identify",
    shMeaning: "to announce, to proclaim",
  },
  išûm: {
    meaning: "to have",
    root: ["", "", ""],
    onlyGstem: true,
  },
  elēlum: {
    themeVowel: "i",
    root: ["Ø", "l", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "stative",
    I_eVerb: true,
    meaning: "to become pure, clean, free",
    dMeaning: "to purify, to keep pure, to consacrate",
  },
  zêrum: {
    themeVowel: "e",
    root: ["z", "Ø", "r"],
    verbalAdjectiveVowel: "ē",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to dislike, to hate, to reject, to avoid",
  },
  egûm: {
    themeVowel: "i",
    meaning: "to be careless",
    root: ["Ø", "g", "Ø"],
    verbClass: "stative",
    I_eVerb: true,
  },
  enûm: {
    themeVowel: "i",
    meaning: "to change, to invert, to revoke",
    root: ["Ø", "n", "Ø"],
    verbClass: "active",
    I_eVerb: true,
  },
  rakāsum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["r", "k", "s"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to bind, to tie, to put on",
    dMeaning: "to contract (with someone)",
  },
  reˀûm: {
    themeVowel: "i",
    root: ["r", "ˀ", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to pasture, to graze",
  },
  tarāṣum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["t", "r", "ṣ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to reach out, to extend, to set up",
  },
  ekēmum: {
    themeVowel: "i",
    root: ["Ø", "k", "m"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to take away, to conquer, to absorb",
  },
  esēḫum: {
    themeVowel: "i",
    root: ["Ø", "s", "ḫ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to assign",
  },
  bârum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["b", "Ø", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "stative",
    meaning: "to be firm",
    dMeaning: "to establish (the truth), to prove",
  },
  kullum: {
    themeVowel: undefined,
    onlyDstem: true,
    root: ["k", "Ø", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: undefined,
    dMeaning: "to hold, to contain",
  },
  raḫāṣum: {
    themeVowel: "i",
    root: ["r", "ḫ", "ṣ"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to flood",
  },
  riāqum: {
    themeVowel: "i",
    durativeVowel: "a",
    root: ["r", "Ø", "q"],
    verbalAdjectiveVowel: "ī",
    verbClass: "stative",
    meaning: "to be empty, idle",
    dMeaning: "to empty",
    shMeaning: "to empty",
  },
  šuklulum: {
    themeVowel: undefined,
    onlySHstem: true,
    root: ["k", "l", "l"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: undefined,
    shMeaning: "to complete, to finish, to accomplish",
  },
  warāqum: {
    themeVowel: "i",
    root: ["w", "r", "q"],
    verbalAdjectiveVowel: "u",
    verbClass: "stative",
    meaning: "to become yellow, green, to turn pale",
  },
  qerûm: {
    themeVowel: "i",
    root: ["q", "r", "Ø"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    I_eVerb: true,
    meaning: "to summon, to invite",
  },
  bêlum: {
    themeVowel: "e",
    root: ["b", "Ø", "l"],
    verbalAdjectiveVowel: "ē",
    verbClass: "active",
    I_eVerb: true,
    meaning: "to rule, to have authority, power over",
  },
  magārum: {
    themeVowel: "u",
    durativeVowel: "a",
    root: ["m", "g", "r"],
    verbalAdjectiveVowel: undefined,
    verbClass: "active",
    meaning: "to be agreeable, to agree, to permit",
  },
  nabûm: {
    themeVowel: "i",
    root: ["n", "b", "Ø"],
    verbalAdjectiveVowel: "i",
    verbClass: "active",
    meaning: "to name, to call, to proclaim",
  },
};

export default lexicon;
